<template>
  <RevButtonBase
    class="text-static-default-hi text-center"
    :target="linkTarget"
    :to="link"
    :tracking="tracking"
  >
    <RevCard class="h-full p-32" :hoverable="true">
      <div class="flex h-full flex-col items-center justify-between">
        <span class="body-1"> "{{ text }}" </span>
        <div class="pt-32">
          <ImageRenderer
            :alt="image?.alt"
            class="mb-16 flex h-72 items-center"
            :height="image?.height"
            :height-mobile="image?.heightMobile"
            :loading="loading"
            :src="image?.src"
            :src-mobile="image?.srcMobile"
            :width="image?.width"
            :width-mobile="image?.widthMobile"
          />

          <span class="body-2">
            {{ publicationDate }}
          </span>
        </div>
      </div>
    </RevCard>
  </RevButtonBase>
</template>

<script lang="ts" setup>
import type { PressArticleContent } from '@backmarket/http-api/src/api-specs-content'
import type { Tracking } from '@backmarket/http-api/src/api-specs-content/models/tracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'

import { Loading } from '../../constants/image-renderer.constants'
import { useLinkTarget } from '../../helpers/link-target/useLinkTarget'
import ImageRenderer from '../ImageRenderer/ImageRenderer.vue'

export type PressArticleCardProps = PressArticleContent & {
  loading?: Loading
  tracking: Tracking
}

const { link } = withDefaults(defineProps<PressArticleCardProps>(), {
  loading: Loading.Lazy,
})

const linkTarget = useLinkTarget(link)
</script>
